<template>
  <div class="row myrow">
    <div class="col-xs-6 mycol">
      <table class="co-executor">
        <thead>
          <tr>
            <td>№ п/п</td>
            <td>
              Почтовый адрес, расположение, цех, участок
            </td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in project.LOCATION_PRODUCTION.items"
            :key="index"
          >
            <template v-if="editable">
              <td>{{ index + 1 }}</td>
              <td
                v-bind:class="{
                  'has-error': hasError(index, 'UF_POSTAL_ADDRESS')
                }"
              >
                <textarea
                  class="i-main-style t-co-executor-style t-dop-style"
                  v-model="item.UF_POSTAL_ADDRESS"
                  maxlength="200"
                  style="width: 96%"
                  @keyup="removeError(index, 'UF_POSTAL_ADDRESS')"
                />
                <span class="frp-input-description"
                  >Доступно для ввода символов:
                  {{ countEntChar(item.UF_POSTAL_ADDRESS, 200) }}
                </span>
                <div class="error-text">
                  {{ errorText(index, "UF_POSTAL_ADDRESS") }}
                </div>
              </td>
              <td>
                <i
                  class="i-delete centerIcon"
                  title="Удалить запись"
                  @click="deleteItem(index)"
                ></i>
              </td>
            </template>
            <template v-else>
              <td>{{ index + 1 }}</td>
              <td>
                {{ item.UF_POSTAL_ADDRESS }}
              </td>
              <td v-if="editable">
                <i
                  class="i-delete centerIcon"
                  title="Удалить запись"
                  @click="deleteItem(index)"
                ></i>
              </td>
              <td v-else></td>
            </template>
          </tr>
        </tbody>
      </table>
      <div class="add-row" v-show="editable">
        <a class="link-add-row" v-on:click="addItem">Добавить запись</a>
      </div>

      <button
        type="button"
        @click="saveItemLocationProducts()"
        v-show="editable"
        class="btn btn-success btn-style-big"
      >
        Сохранить
      </button>
      <button
        type="button"
        @click="getListLocationProducts()"
        v-show="editable"
        class="btn btn-default btn-style-big"
      >
        Отмена
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ProjectsService } from "@/common/api.service";
//import DigitalSolutionList from "@/components/project/form/lists/DigitalSolutionList";

export default {
  name: "technological_line",
  props: ["project", "editable"],
  components: {},
  data() {
    return {
      listErrors: []
    };
  },
  methods: {
    hasError(col, field) {
      if (typeof this.listErrors[col] !== "undefined") {
        if (typeof this.listErrors[col][field] !== "undefined") {
          return true;
        }
      }

      return false;
    },
    errorText(col, field) {
      if (typeof this.listErrors[col] !== "undefined") {
        if (typeof this.listErrors[col][field] !== "undefined") {
          return this.listErrors[col][field];
        }
      }
      return "";
    },
    removeError(col, field) {
      if (typeof this.listErrors[col] !== "undefined") {
        if (typeof this.listErrors[col][field] !== "undefined") {
          Vue.delete(this.listErrors[col], field);
        }
      }
      return false;
    },
    addItem() {
      if (typeof this.project.LOCATION_PRODUCTION.items === "undefined") {
        this.project.LOCATION_PRODUCTION = {
          items: []
        };
      }
      this.project.LOCATION_PRODUCTION.items.push({
        UF_TEGNOLOGICAL_LINE: "",
        UF_DATE_COMPLETION: "",
        UF_POSTAL_ADDRESS: ""
      });
    },
    deleteItem(index) {
      this.project.LOCATION_PRODUCTION.items.splice(index, 1);
    },
    saveItemLocationProducts() {
      this.listErrors = [];
      ProjectsService.saveLocationProductsProject(this.$route.params.id, {
        items: this.project.LOCATION_PRODUCTION.items
      }).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });

            if (!this.listErrors[text.DOP_INFO.ROW_NUM]) {
              this.listErrors[text.DOP_INFO.ROW_NUM] = [];
            }
            this.listErrors[text.DOP_INFO.ROW_NUM][text.DOP_INFO.COL[0]] =
              text.TEXT;
          }, this);
          if (data.isSetTansactionBD) {
            this.project.LOCATION_PRODUCTION.items = data.items;
          }
          return;
        } else {
          this.$toasted.show("Данные о месте реализации проекта сохранены", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          if (data.isSetTansactionBD) {
            this.project.LOCATION_PRODUCTION.items = data.items;
          }

          if (data.infoArr.length) {
            data.infoArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "orange",
                position: "bottom-right",
                duration: 4000
              });
            }, this);
          }
        }
      }, this);
    },
    getListLocationProducts() {
      ProjectsService.getLocationProductsProject(this.$route.params.id).then(
        ({ data }) => {
          if (data) {
            this.project.LOCATION_PRODUCTION.items = data;
          }
        },
        this
      );
    },
    countEntChar(value, limit) {
      if (value) {
        const length = String(value).length;
        return length > limit ? 0 : limit - length;
      }
      return limit;
    }
  }
};
</script>

<style scoped></style>
